import BossModel from "@/models/BossModel";
import Traveller from "@/models/Dossier/Traveller/Traveller";
import ProposalProductDetailDossierTraveller
    from "@/models/Proposal/Product/Detail/ProposalProductDetailDossierTraveller";
import Composition from "@/models/Product/Detail/Composition/Composition";
import Product from "@/models/Proposal/Product/Product";

export default class Detail extends BossModel {

    static apiUrl = 'proposal/product/detail';

    static entity = 'proposalProductDetails';

    static fields() {
        return {
            id: this.number(null).nullable(),
            proposal_product_id: this.number(null).nullable(),
            product_detail_composition_id: this.number(null).nullable(),
            count_adults: this.number(null).nullable(),
            count_children: this.number(null).nullable(),
            count_babys: this.number(null).nullable(),
            count_quantity: this.number(null).nullable(),
            purchase_price: this.attr(null),
            sale_price: this.attr(null),
            agent_name: this.attr(null),
            internal_name: this.attr(null),
            applied_discounts: this.attr(null),
            prediction_start_date: this.attr(null),
            is_price_extended: this.boolean(false),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            composition: this.belongsTo(Composition, 'product_detail_composition_id'),
            product: this.belongsTo(Product, 'proposal_product_id'),
            travellers: this.belongsToMany(Traveller, ProposalProductDetailDossierTraveller, 'proposal_product_detail_id', 'dossier_traveller_id'),
        }
    }

    UpdateTravellers(travellerIds = []) {
        return this.constructor.api().beforeInsert(() => {
            this.constructor.query().with('travellers').find(this.id).travellers.forEach(traveller => {
                traveller.pivot.$delete();
            });
        }).action(this.id + '/travellers').update({
            traveller_ids: travellerIds
        });
    }
}
